/* eslint-disable react-hooks/rules-of-hooks */
import { useGetApiRequests } from "../../../common/CommonExport";

const organisationChart = useGetApiRequests("employeeOrganisationChart", "GET");

export const getOrganisationChartData = async (orgId: number): Promise<any> => {
  try {
    const response = await organisationChart(null, { organisationId: orgId });
    if ("data" in response) {
      return response.data;
    } else {
      console.error("Response is not an AxiosResponse:", response);
      return null;
    }
  } catch (error) {
    console.error("Error fetching organization chart data:", error);
    throw error;
  }
};
